import { module } from 'angular';
import { bgImageFilter } from './bg-image.filter';
import { momentFilter } from './moment.filter';
import { joinFilter } from './join.filter';

export const SharedFiltersModule = module('shared.filters', [])
  .filter('bgImage', bgImageFilter)
  .filter('moment', momentFilter)
  .filter('join', joinFilter);



// WEBPACK FOOTER //
// ./app/shared/filters/shared-filters.module.ts